"use client";

import { NavLink } from "react-router-dom";

import styles from "../sub-menu/subMenu.module.scss";
import CurrencyImage from "../../assets/menu-icons/currency.svg";
import EmailImage from "../../assets/menu-icons/email.svg";
import OrderConfigImage from "../../assets/menu-icons/orderConfig.svg"
import FtpImage from "../../assets/menu-icons/ftp.svg";
import sevenElevenImage from "../../assets/menu-icons/webSites.svg";
import PdfImage from "../../assets/menu-icons/pdf.svg";
import CreateImage from "../../assets/menu-icons/create.svg";
import ExcelImage from "../../assets/menu-icons/excel.svg";
import SwitchboardRoutingImage from "../../assets/menu-icons/switchboard.svg";
import FunctionSetupImage from "../../assets/menu-icons/function.svg";
import PhoneImage from "../../assets/menu-icons/phone.svg";
import ApiImage from "../../assets/menu-icons/api.svg";
import CreateSummaryImage from "../../assets/menu-icons/create-summary.svg";
import SpecrightImage from "../../assets/menu-icons/specright.svg";
import RegionMappingsImage from "../../assets/menu-icons/region-mappings.svg";
import BajaOrdersImage from "../../assets/menu-icons/baja.svg";
import PoInvoiceImage from "../../assets/menu-icons/po-invoice.svg";
import PoCreateImage from "../../assets/menu-icons/po-create.svg";
import SoPickImage from "../../assets/menu-icons/so-pick.svg";
import CreateCreditInvoicesImage from "../../assets/menu-icons/CreateCreditInvoices.svg";
import ItemOrShipXrefImage from "../../assets/menu-icons/ItemOrShipToXrefImage.svg";
import DuplicateOrdersSummaryImage from "../../assets/menu-icons/DuplicateOrdersSummary.svg";
import KrogerInvoiceImage from "../../assets/menu-icons/krogerinvoice.svg";
import FeatureFlagDataContext from "../../store/featureFlags";
import RestageOrderImage from "../../assets/menu-icons/restageOrder.svg";
import { useContext } from "react";

const SideSubmenu = (props) => {
  const { menuItem } = props;
  const { isMenuExpanded } = props;
  const [featureFlags, setFeatureFlags] = useContext(FeatureFlagDataContext);

  return (
    <>
      {menuItem?.menuItems?.map((item) => {
        return (
          <div className={styles.submenuContainer} key={item?.id}>
            <NavLink
              to={item?.path}
              className={({ isActive }) =>
                isActive
                  ? ` ${styles.submenuItem} ${styles.active} ${!isMenuExpanded ? styles.submenuWithOutPadding : ""
                  }`
                  : `${styles.submenuItem} ${!isMenuExpanded ? styles.submenuWithOutPadding : ""
                  }`
              }
              activeclassname="active"
            >
              {/* {item?.icon && (
                <i className={item?.icon} style={{ marginRight: "0.4rem" }}></i>
              )} */}
              <div className="flex">
                {featureFlags?.enableModernMenu ? (
                  <div className="flex align-items-center justify-content-center mr-4">
                    <img
                      src={
                        item?.icon === "CurrencyImage" ? CurrencyImage
                          : item?.icon === "EmailImage" ? EmailImage
                            : item?.icon === "FtpImage" ? FtpImage
                              : item?.icon === "sevenElevenImage" ? sevenElevenImage
                                : item?.icon === "PdfImage" ? PdfImage
                                  : item?.icon === "CreateImage" ? CreateImage
                                    : item?.icon === "ExcelImage" ? ExcelImage
                                      : item?.icon === "SwitchboardRoutingImage" ? SwitchboardRoutingImage
                                        : item?.icon === "FunctionSetupImage" ? FunctionSetupImage
                                          : item?.icon === "PhoneImage" ? PhoneImage
                                            : item?.icon === "ApiImage" ? ApiImage
                                              : item?.icon === "CreateSummaryImage" ? CreateSummaryImage
                                                : item?.icon === "SpecrightImage" ? SpecrightImage
                                                  : item?.icon === "RegionMappingsImage" ? RegionMappingsImage
                                                    : item?.icon === "BajaOrdersImage" ? BajaOrdersImage
                                                      : item?.icon === "POInvoiceImage" ? PoInvoiceImage
                                                        : item?.icon === "POCreationImage" ? PoCreateImage
                                                          : item?.icon === "SOPickingImage" ? SoPickImage
                                                            : item?.icon === "OrderConfigImage" ? OrderConfigImage
                                                              : item?.icon === "CreateCreditInvoicesImage" ? CreateCreditInvoicesImage
                                                                : item?.icon === "DuplicateOrdersSummaryImage" ? DuplicateOrdersSummaryImage
                                                                  : item?.icon === "ItemOrShipXrefImage" ? ItemOrShipXrefImage
                                                                    : item?.icon === "KrogerInvoiceImage" ? KrogerInvoiceImage
                                                                      : item?.icon === "RestageOrderImage" ? RestageOrderImage
                                                                        :""
                      }

                      alt="Email Icon"
                      height="24px"
                      width="24px"
                    />
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="flex align-items-center justify-content-center">
                  {item?.submenu}
                </div>
              </div>
            </NavLink>
          </div>
        );
      })}
    </>
  );
};

export default SideSubmenu;
